module.exports = __webpack_public_path__ + "img/zt.34eea914.svg";